import {  ApiResponse, CancelReason, Order, OrderAddressData, OrderPayload, OrdersResponse } from "../../../types";
import { getRequestWithAuth, getRequestWithParamsAndQuery, patchRequestWithAuth, postRequestWithAuth } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";
const api = getApiWithVersion(API_VERSION.V1);
export interface API_Order {

    orderCoomplete(orderPayload: OrderPayload, sessionCode: string, query?: any | null): Promise<ApiResponse<Order>>;
    fetchOrders(user_id: number): Promise<ApiResponse<OrdersResponse[]>>;
    searchOrders(
        user_id: number,
        query: Record<string, any>
    ): Promise<ApiResponse<OrdersResponse[]>>;

  fetchOrderAddress(orderId: string | number): Promise<ApiResponse<OrderAddressData>>;

  getCancelReasons(): Promise<ApiResponse<CancelReason[]>>;
  cancelOrder(
    orderId: string | number,
    userId: string | number,
    payload: { customReason: string }
  ): Promise<ApiResponse<{ message: string }>>;

  rescheduleOrder(
  orderId: string | number,
  userId: string | number,
  payload: {
    reschedule_date: string;
    reschedule_reason: string;
  }
): Promise<ApiResponse<any>>;


}

const order: API_Order = {
    orderCoomplete(orderPayload, sessionCode, utm) {
        return utm && Object.entries(utm).length > 0
            ? postRequestWithAuth(api.ORDER_COMPLETE, orderPayload, sessionCode, utm)
            : postRequestWithAuth(api.ORDER_COMPLETE, orderPayload, sessionCode)
    },

    fetchOrders(user_id) {
        return getRequestWithAuth(api.ORDERS, user_id);
    },


    searchOrders(user_id, query) {
        return getRequestWithAuth(
            api.ORDERS,
            [String(user_id), "search"],
            query
        );
    },

     fetchOrderAddress(orderId) {
    return getRequestWithAuth(api.ORDER_ADDRESS, orderId);
  },

   getCancelReasons() {
    return getRequestWithAuth(api.CANCEL_REASONS);
  },
  
  rescheduleOrder(orderId, userId, payload) {
  return patchRequestWithAuth(
    api.RESCHEDULE_ORDER,
    payload,
    [String(orderId), String(userId)]
  );
},


  cancelOrder(orderId, userId, payload) {
  return patchRequestWithAuth(
    api.CANCEL_ORDER,
    payload,
    [String(orderId), String(userId)]
  );

  
},



};

export default order

